import React from 'react';
import ProjectDetailLayout from '../../components/ProjectDetailLayout';

const projectData = {
  title: 'ESP BoardPulse',
  productName: 'ESP BoardPulse',
  productVersion: '1.0.0',  
  description: 'A comprehensive desktop application for testing, monitoring, and managing ESP32 and Arduino development boards with advanced debugging capabilities.',
  longDescription: `ESP BoardPulse is a powerful desktop application specifically designed for developers working with ESP32 and Arduino development boards. This comprehensive platform streamlines the development workflow by providing essential tools for testing, monitoring, and debugging hardware projects.

  The application features an intuitive interface that makes hardware development more accessible, whether you're a beginner learning embedded systems or an experienced developer working on complex IoT projects. With real-time monitoring capabilities and advanced debugging tools, ESP BoardPulse eliminates the complexity often associated with hardware development.

  Built as a native desktop application, ESP BoardPulse offers optimal performance and seamless integration with your development environment, making it an indispensable tool for any hardware developer's toolkit.`,
  image: '/images/esp-boardpulse.png',
  tags: ['Desktop App', 'Hardware Integration', 'ESP32', 'Arduino', 'Embedded Systems'],
  features: [
    'Connect to ESP32 and Arduino boards seamlessly',
    'Real-time GPIO pin monitoring with visual indicators',
    'Live serial output monitoring and logging',
    'Firmware flashing capabilities for ESP32 boards',
    'Onboard LED and component control interface',
    'Comprehensive log data export functionality',
    'Cross-platform desktop application support'
  ],
  technologies: [
    'Python',
    'PySide6 - Qt for Python (Modern UI Framework)',
    'Serial Communication Protocols',
    'Hardware APIs and Device Drivers',
    'USB/Serial Port Management',
    'Embedded Systems Programming',
    'Cross-platform Development',
    'Real-time Data Processing',
    'File I/O and Data Export Systems'
  ],
  github: 'https://github.com/AbhishekB2023',
  downloadLink: '/downloads/ESP_BoardPulse_v1.0.0.zip',
  downloadFileName: 'ESP_BoardPulse_v1.0.0.zip',
  projectType: 'Desktop Application',
  status: 'Active Development',
  compatibility: ['Windows 10/11 (64-bit)', 'macOS (Coming Soon)'],
  keyHighlights: [
    'Native desktop performance and reliability',
    'Direct hardware communication without browser limitations',
    'Streamlined hardware development workflow',
    'Real-time monitoring and debugging capabilities',
    'Professional-grade logging and export features for documentation',
    'Built by a developer who understands both software and hardware challenges'    
  ]
};

const EspBoardpulse = () => {
  return <ProjectDetailLayout project={projectData} />;
};

export default EspBoardpulse;





